import 'babel-polyfill'
import 'es6-promise/auto'
import es6Promise from 'es6-promise'
import Vue from 'vue'
import VueRouter from 'vue-router'
import router from '@/router'
import store from '@/store'
import PortalVue from 'portal-vue'
import App from '@/App.vue'
import Notifications from 'vue-notification'
import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import Meta from 'vue-meta'
import vueDebounce from 'vue-debounce'
import translation from '@/translation'
// import fastclick from 'fastclick-vue'
import { COOKIES_DOMAIN } from '@/utils/modules/Common.js'
import { mapState } from 'vuex'
import { Check } from '@/utils/defines/Translation'
import LottieAnimation from 'lottie-web-vue'
import _ from 'lodash'
import VueCookies from 'vue-cookies'

import { ModalPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

es6Promise.polyfill()
Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV === 'development'
Vue.use(VueRouter)
Vue.use(PortalVue)
Vue.use(translation)
Vue.use(ModalPlugin)
VueCookies.config(Infinity, null, COOKIES_DOMAIN)
Vue.use(VueCookies)
// Bootstarp vue
// fastclick.attach(document.body)

// refs : https://pozafly.github.io/html/meta-tag-and-vue-meta/
Vue.use(Meta, {
	keyName: 'metaInfo',
	attribute: 'data-vue-meta',
	ssrAttribute: 'data-vue-meta-server-rendered',
	tagIDKeyName: 'vmid', // 변화시키는 구분 값
	refreshOnceOnNavigation: true,
})

// refs : https://openbase.com/js/vue-notification/documentation
Vue.use(Notifications)

// refs: https://www.npmjs.com/package/vue-debounce#installation
Vue.use(vueDebounce, {
	defaultTime: '1000ms',
	listenTo: ['input'],
})

// refs: https://www.npmjs.com/package/lottie-web-vue
Vue.use(LottieAnimation)

// refs: https://vcalendar.io/
Vue.component('v-calendar', Calendar)
Vue.component('v-date-picker', DatePicker)

import '@/styles/global/_common.scss'
import '@/styles/global/_toast.scss'
import '@/styles/global/_modal.scss'

Vue.prototype.$_ = _
// Vue.prototype.$cookies = cookies

Array.prototype.remove = function (data, key) {
	const idx = this.findIndex(function (item) {
		if (key == null || key == undefined) {
			return item == data
		} else {
			return item[key] === data || item[key] === data[key]
		}
	}) // findIndex = find + indexOf
	if (idx > -1) this.splice(idx, 1)
}
Array.prototype.removeAt = function (idx) {
	if (idx > -1) this.splice(idx, 1)
}
Array.prototype.removeAll = function (list, key) {
	list.forEach(x => this.remove(x, key))
}

// iOS Safari 등에서 100vh가 주소창/도구모음을 포함한 전체 높이로 계산되어
// 화면 하단 요소가 가려지는 문제를 막기 위해, 실제 보이는 뷰포트 높이를
// --vh 커스텀 프로퍼티로 주입 (calc(var(--vh, 1vh) * 100)으로 사용)
function setViewportHeightUnit() {
	document.documentElement.style.setProperty(
		'--vh',
		`${window.innerHeight * 0.01}px`
	)
}
setViewportHeightUnit()
window.addEventListener('resize', setViewportHeightUnit)
window.addEventListener('orientationchange', setViewportHeightUnit)

new Vue({
	render: h => h(App),
	store,
	router,
	created() {
		if (!this.isMobile()) {
			location.href = location.href.replace(
				'mobile.lab-manager.com',
				'pro.lab-manager.com'
			)
		}
	},
	watch: {
		user() {
			Check.English = false
			if (this.user.language == 'en') {
				Check.English = true
			} else {
				if (navigator.language.includes('en')) Check.English = true
			}
			Vue.use(translation)
		},
	},
	data() {
		return {
			previousPage: null,
		}
	},
	computed: {
		...mapState('user', ['user', 'institute', 'userPermission']),
		isEnglish() {
			return this.user.language == 'en'
		},
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.previousPage = from
		})
	},
	methods: {
		isMobile() {
			const UserAgent = navigator.userAgent

			if (
				UserAgent.match(
					/iPhone|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i
				) != null ||
				UserAgent.match(/LG|SAMSUNG|Samsung/) != null
			) {
				return true
			} else {
				return false
			}
		},
	},
}).$mount('#app')
